import React from 'react';
import { useBenefits } from 'features/resources/hooks';
import { BenefitsPageContent } from './BenefitsPageContent';

export const BenefitsPage: React.FC = () => <BenefitsPageContent {...useBenefits()} />;
